// Current DigiByte Core release shown across the site. Update on each new release.
export const CORE_RELEASE = 'v9.26.7';
